import { render, staticRenderFns } from "./TableListSegmentPanel.vue?vue&type=template&id=80bc0256&scoped=true"
import script from "./TableListSegmentPanel.vue?vue&type=script&lang=js"
export * from "./TableListSegmentPanel.vue?vue&type=script&lang=js"
import style0 from "./TableListSegmentPanel.vue?vue&type=style&index=0&id=80bc0256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bc0256",
  null
  
)

export default component.exports